import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link as ReactLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import {
    TableRow,
    TableCell,
    TableCellInfo,
    FormLine,
    FormField,
    FormInput,
    FormLabel,
    Link,
    Title,
} from 'yurstrap';

import { buildQueryParameters } from 'helpers/RoutesHelpers';

import {
    setCookie,
    getCookieSelector,
    isCookieAcceptedSelector,
} from '../reduxModules/ConsentManagementPlatform';

import Routes from '../constants/Routes';

const propTypes = {
    AppActions: PropTypes.shape({
        setCookie: PropTypes.func.isRequired,
    }).isRequired,
    cookie: PropTypes.object.isRequired,
    isCookieAccepted: PropTypes.bool.isRequired,
};

export class CMPCookiesRow extends Component {

    constructor(props) {
        super(props);
        this.toggleCookie = this.toggleCookie.bind(this);
    }

    toggleCookie() {
        const {
            AppActions,
            isCookieAccepted,
            cookie,
        } = this.props;
        const cookieId = cookie.id;
        AppActions.setCookie(cookieId, !isCookieAccepted);
    }

    renderCookieRow() {
        const {
            cookie,
            isCookieAccepted,
        } = this.props;
        if (cookie.group === 'MARKETING') return null;
        return (
            <TableCell>
                <FormLine className="mb-0">
                    <FormField type="toggle">
                        <FormInput
                            className="mr-4"
                            id={`cookie-${cookie.id.toLowerCase()}-acceptance`}
                            type="checkbox"
                            checked={isCookieAccepted}
                            onChange={this.toggleCookie}
                        />
                        <FormLabel htmlFor={`cookie-${cookie.id.toLowerCase()}-acceptance`} />
                    </FormField>
                </FormLine>
            </TableCell>
        );
    }

    render() {
        const { cookie } = this.props;
        const params = {
            'cmp-modal': Routes.COOKIE_DETAILS.link.replace(':cookieId', cookie.id.toLowerCase()),
        };
        const queryParams = buildQueryParameters(params);
        const isMarketingGroup = cookie.group === 'MARKETING';
        return (
            <TableRow
                key={cookie.id}
                className="u-slide-in--top"
            >
                <TableCell
                    colSpan={isMarketingGroup ? '2' : '1'}
                >
                    <Title
                        componentClass="h6"
                        className="mb-1"
                    >
                        {cookie.title}
                    </Title>
                    <TableCellInfo
                        className="mb-3"
                    >
                        {cookie.description}
                    </TableCellInfo>
                    <Link
                        className="mr-5 u-font-size--2"
                        to={{ search: `?${queryParams}` }}
                        componentClass={ReactLink}
                    >
                        En savoir plus
                    </Link>
                    <Link
                        href={cookie.link}
                        target="_blank"
                        className="u-display__b u-font-size--2 mt-2"
                    >
                        Voir le site officiel
                    </Link>
                </TableCell>
                {this.renderCookieRow()}
            </TableRow>
        );
    }

}

CMPCookiesRow.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
    return {
        cookie: getCookieSelector(state, ownProps.cookieId),
        isCookieAccepted: isCookieAcceptedSelector(state, ownProps.cookieId),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            setCookie,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CMPCookiesRow);
